import { runtimeConfig } from '@/config/runtime';
import type { AiSite } from '@/types/runtime-config';
import { get } from './api';
import { getChatSiteByLanguage } from './chat_api';

export interface SuggestionOption {
  tag_id: string;
  tag_name: string;
  tag_type: string;
  hit_count: number;
}

export interface TagHitsData {
  site: AiSite | 'all';
  lang: 'zh' | 'en';
  range_days: number;
  source?: string;
  total_searches: number;
  queried: SuggestionOption[];
  matched: SuggestionOption[];
}

export interface TagHitsResponse {
  code: string;
  message: string;
  data: TagHitsData;
}

/** 获取当前站点近 30 天的热门搜索标签。 */
export const getTagHits = (signal?: AbortSignal): Promise<TagHitsResponse> => {
  const url = new URL(runtimeConfig.tagHitsApiUrl, window.location.origin);
  url.searchParams.set('site', getChatSiteByLanguage());
  url.searchParams.set('days', '30');
  url.searchParams.set('lang', runtimeConfig.lang === 'ch' ? 'zh' : 'en');

  return get<TagHitsResponse>(url.toString(), { signal });
};
